import React from "react";

export default function BirdCanvas(props) {
  return (
    <canvas
      id={props.id}
      className="boidsCanvas"
      width={props.canvasWidth}
      height={props.canvasHeight}
      style={{
        backgroundColor: "black",
        opacity: props.opacity
      }}
    />
  );
}
